/**
 * Datos para la presentación Día 3 · The Business Level (proyector / sala).
 * Actualizar aquí la grilla y aliados cuando Mercadeo confirme cambios en parrilla.
 */

/** Acento “dark tech” (neón cian) — solo copy/UI en esta presentación. */
export const STRATEGIC_NEON_CYAN = '#22d3ee';

/** Slide 1 · posicionamiento: de “medio” a plataforma de mercadeo. */
export const strategicOpening = {
  platformLabel: 'Plataforma de Soluciones de Mercadeo',
  headline: 'No vendemos pautas, conectamos marcas con audiencias reales.',
  subline: 'Bienvenidos al Branded Content Inteligente.',
  body:
    'El fin de la publicidad intrusiva. TNO orquesta streaming, On-Demand y Digest para que su inversión sea conversación medible —no solo un corte al aire.',
};

/** Slide 3 · audiencia y distribución (complemento a métricas de volumen). */
export const impactAudienceMetrics = [
  {
    value: '92%',
    label: 'Audiencia en Suramérica (concentración principal en Venezuela).',
    accent: '#00bcd4',
  },
  {
    value: '4,5%',
    label: 'Norteamérica en la distribución global de la señal.',
    accent: '#26c6da',
  },
  {
    value: '55% / 45%',
    label: 'Mujeres y hombres; segmentos A, B y C · edades 18–48.',
    accent: '#4dd0e1',
  },
];

/** Slide 5 · aliados por rubro (referencia sala / evento). */
export const strategicAlliesByCategory = [
  {
    category: 'Alimentos y bebidas',
    brands: [
      { name: 'Agua Glacier', logoPath: '/images/logos/glacier.png', circleFill: 'white' },
      { name: 'Lácteos Barinas', logoPath: '/images/logos/barinas.JPG', circleFill: 'white' },
      { name: 'Mabbax Café', logoPath: '/images/logos/mabbax.jpg', circleFill: 'black' },
      { name: 'ALKIMIQ', logoPath: '/images/logos/alkimiq.jpeg', circleFill: 'white' },
      { name: 'Alimentos Doña Rosa', logoPath: '/images/logos/alimentoddonarosa.jpeg', circleFill: 'black' },
      { name: 'Papaupa', logoPath: '/images/logos/papaupa.jpeg', circleFill: 'black' },
      { name: 'Familia Saludable', logoPath: '/images/logos/familiasaludable.jpeg', circleFill: 'white' },
    ],
  },
  {
    category: 'Servicios y turismo',
    brands: [
      { name: 'Posada Amada Mía', logoPath: '/images/logos/posada.jpg', circleFill: 'white' },
      { name: 'Protecno Networks', logoPath: '/images/logos/protecno.jpeg', circleFill: 'white' },
      { name: 'Zerolo Planner', logoPath: '/images/logos/zerolo.jpeg', circleFill: 'white' },
    ],
  },
  {
    category: 'Retail y entretenimiento',
    brands: [{ name: 'Lion Bar', logoPath: '/images/logos/lion.png', circleFill: 'white' }],
  },
];

/** Slide 7 · hoja de ruta de inversión. */
export const investmentRoadmap2026 = [
  {
    phase: 'Fase 1',
    title: 'Presencia en vivo',
    line: 'Antena, menciones integradas y clips listos para redes.',
  },
  {
    phase: 'Fase 2',
    title: 'Digest y SEO',
    line: 'Artículos patrocinados con posicionamiento editorial y buscadores.',
  },
  {
    phase: 'Fase 3',
    title: 'On-Demand y segmentación',
    line: 'Integración en catálogo con narrativas de marca y pauta contextual.',
  },
];

export const strategicClosing = {
  tagline: 'El futuro no se sintoniza, se construye.',
  ctaNote:
    'En sala: escanee el QR de la propuesta personalizada (si está disponible) o use el Media Kit digital.',
  contactName: 'Jaqueline Arteaga',
  contactRole: 'Dirección de Comercialización · TNO Network',
};

/** Métricas ecosistema (alineadas con TNOCON / Business Level). */
export const businessLevelMetrics = [
  { value: '30.000+', label: 'Conexiones mensuales al streaming (señal en vivo y plataforma).', accent: '#00695c' },
  { value: '90.000+', label: 'Seguidores orgánicos en el ecosistema social TNO.', accent: '#00838f' },
  { value: '40+', label: 'Producciones originales On-Demand en catálogo.', accent: '#5e35b1' },
  { value: '25+', label: 'Programas y formatos en vivo en la parrilla semanal.', accent: '#c62828' },
];

/**
 * Grilla de programación activa por nicho (nombres para sala comercial).
 * Incluye formatos en antena y verticales recurrentes citados en media kits y propuestas TNO.
 */
export const programGridByNiche = [
  {
    niche: 'Informativo y reportajes',
    programs: [
      {
        name: 'Noticias TNO',
        note: 'Sol Vargas · rigor informativo y streaming global',
        href: 'https://tnonetwork.com/show/noticiastno',
      },
      {
        name: 'TNO Sports',
        note: 'Yeraldin Marrero · +100K Instagram · agenda deportiva TNO',
        href: 'https://tnonetwork.com/show/tnosports',
      },
      {
        name: 'Expedientes del Delito',
        note: 'Investigación y relato ciudadano en profundidad',
        href: 'https://tnonetwork.com/show/expedientesdeldelito',
        showSlug: 'expedientesdeldelito',
      },
    ],
  },
  {
    niche: 'Negocios, empresas y emprendimiento',
    programs: [
      {
        name: 'TNO Business',
        note: 'Performance, marcas y conversión',
        href: 'https://tnonetwork.com/show/tnobusiness',
        showSlug: 'tnobusiness',
      },
      {
        name: 'Franquicias en Venezuela',
        note: 'Argenis Carpio · escalabilidad B2B',
        href: 'https://tnonetwork.com/show/franquiciasenvenezuela',
        showSlug: 'franquiciasenvenezuela',
      },
      {
        name: 'Comercio Corporativo',
        note: 'Darío Ascanio · economía, gestión y éxito empresarial',
        href: 'https://tnonetwork.com/show/comerciocorporativo',
        showSlug: 'comerciocorporativo',
      },
    ],
  },
  {
    niche: 'Marketing',
    programs: [
      {
        name: 'Marketing en Movimiento',
        note: 'Loyola Rosales y Luzmey Hernández · expertas en marketing y negocios',
        href: 'https://tnonetwork.com/show/marketingenmovimiento',
        showSlug: 'marketingenmovimiento',
      },
      {
        name: 'En Producción con MEM',
        note: 'Tras bambalinas · storytelling, marca e industria creativa para mercadeo',
        href: 'https://tnonetwork.com/show/enproduccionconmem',
        showSlug: 'enproduccionconmem',
      },
    ],
  },
  {
    niche: 'Entrevistas',
    programs: [
      {
        name: 'Marketing en Movimiento',
        note: 'Loyola Rosales y Luzmey Hernández · expertas en marketing y negocios',
        href: 'https://tnonetwork.com/show/marketingenmovimiento',
        showSlug: 'marketingenmovimiento',
      },
      {
        name: 'Franquicias en Venezuela',
        note: 'Argenis Carpio · fundadores y directivos del ecosistema de franquicias',
        href: 'https://tnonetwork.com/show/franquiciasenvenezuela',
        showSlug: 'franquiciasenvenezuela',
      },
      {
        name: 'En Producción con MEM',
        note: 'María Eugenia Moreno · voceros y casos del mundo publicitario',
        href: 'https://tnonetwork.com/show/enproduccionconmem',
        showSlug: 'enproduccionconmem',
      },
      {
        name: 'Legalmente en Familia',
        note: 'Leila Davogustto Luna · conversación legal en antena',
        href: 'https://tnonetwork.com/show/legalmenteenfamilia',
        showSlug: 'legalmenteenfamilia',
      },
      {
        name: '3 de Copas con Zidney',
        note: 'Transformación personal y conversación en comunidad',
        href: 'https://tnonetwork.com/show/3decopas',
        showSlug: '3decopas',
      },
      {
        name: 'Comercio Corporativo',
        note: 'Darío Ascanio · líderes empresariales y gestión',
        href: 'https://tnonetwork.com/show/comerciocorporativo',
        showSlug: 'comerciocorporativo',
      },
      {
        name: 'La Dosis Positiva',
        note: 'Yanira Bocaranda · bienestar, productividad y crecimiento personal',
        href: 'https://tnonetwork.com/show/ladosispositiva',
        showSlug: 'ladosispositiva',
      },
      {
        name: 'TNO Business',
        note: 'Líderes, casos de éxito y análisis de coyuntura empresarial',
        href: 'https://tnonetwork.com/show/tnobusiness',
        showSlug: 'tnobusiness',
      },
    ],
  },
  {
    niche: 'Educación',
    programs: [{ name: 'Oratoría Estratégica', note: 'TNO Academy · voz y presencia en cámara' }],
  },
  {
    niche: 'Zona Life',
    programs: [
      {
        name: 'La Dosis Positiva',
        note: 'Yanira Bocaranda · productividad y bienestar',
        href: 'https://tnonetwork.com/show/ladosispositiva',
        showSlug: 'ladosispositiva',
      },
      {
        name: 'Vivir en Equilibrio',
        note: 'Liliana Fernandes · hábitos y calidad de vida',
        href: 'https://tnonetwork.com/show/vivirenequilibrio',
        showSlug: 'vivirenequilibrio',
      },
      {
        name: 'En Sintonía con tu Salud',
        note: 'Dra. Grecia Andreina · bienestar integral y salud preventiva',
        href: 'https://tnonetwork.com/show/ensintoniacontusalud',
        showSlug: 'ensintoniacontusalud',
      },
      {
        name: 'Frecuencia Materna',
        note: 'Maternidad holística e integral · encuentro y complicidad en antena',
        href: 'https://tnonetwork.com/show/frecuenciamaterna',
        showSlug: 'frecuenciamaterna',
      },
    ],
  },
  {
    niche: 'De panza a brazos',
    programs: [
      {
        name: 'Frecuencia Materna',
        note: 'Maternidad holística e integral · bienestar desde la gestación',
        href: 'https://tnonetwork.com/show/frecuenciamaterna',
        showSlug: 'frecuenciamaterna',
      },
      {
        name: 'Madres sin Filtro',
        note: 'Motivación y maternidad real · conversación sin tabúes',
        href: 'https://tnonetwork.com/show/madressinfiltro',
        showSlug: 'madressinfiltro',
      },
      {
        name: 'Somos Padres',
        note: 'Yelitza Yánez · crianza, salud y bienestar para toda la familia',
        href: 'https://tnonetwork.com/show/somospadres',
        showSlug: 'somospadres',
      },
    ],
  },
  {
    niche: 'Lo divino y lo profano',
    programs: [
      {
        name: 'Punto de Fe con Margarita Toledo',
        note: 'Programa ancla · valores y espiritualidad',
        href: 'https://tnonetwork.com/show/puntodefe',
        showSlug: 'puntodefe',
      },
      {
        name: 'A una Voz',
        note: 'Reflexión, fe y conversación de comunidad',
        href: 'https://tnonetwork.com/show/aunavoz',
        showSlug: 'aunavoz',
      },
      { name: '3 de Copas con Zidney', note: 'Transformación, estilo de vida y conversación en comunidad' },
    ],
  },
  {
    niche: 'Historias humanas',
    programs: [
      {
        name: 'Después del evento',
        note: 'Podcast y relatos · vidas reales y conversación en TNO Network',
        href: 'https://tnonetwork.com/show/despuesdelevento',
        showSlug: 'despuesdelevento',
      },
    ],
  },
  {
    niche: 'Justicia y relato ciudadano',
    programs: [
      { name: 'Expedientes del Delito', note: 'Narrativa legal y casos en profundidad' },
      {
        name: 'Legalmente en Familia',
        note: 'Leila Davogustto Luna · orientación legal para la familia venezolana',
        href: 'https://tnonetwork.com/show/legalmenteenfamilia',
        showSlug: 'legalmenteenfamilia',
      },
    ],
  },
  {
    niche: 'Inmobiliario y comunidad',
    programs: [
      {
        name: 'Dr. Condominio Radio',
        note: 'Dr. Julio César López Galea · PH y copropiedad',
        href: 'https://tnonetwork.com/show/doctorcondominioradio',
        showSlug: 'doctorcondominioradio',
      },
      {
        name: 'Vida Inmobiliaria',
        note: 'Mercado inmobiliario, tendencias y conversación con expertos',
        href: 'https://tnonetwork.com/show/vidainmobiliaria',
        showSlug: 'vidainmobiliaria',
      },
      {
        name: 'Alma House Radio',
        note: 'Comunidad y lifestyle residencial · voces del proyecto en antena',
        href: 'https://tnonetwork.com/show/almahouseradio',
        showSlug: 'almahouseradio',
      },
    ],
  },
  {
    niche: 'Arte, Espectáculos y Entretenimiento',
    programs: [
      {
        name: 'Siempre más Música',
        note: 'Música, entretenimiento y conversación en antena',
        href: 'https://tnonetwork.com/show/siempremasmusica',
        showSlug: 'siempremasmusica',
      },
      {
        name: 'Show Time',
        note: 'Revista · arte, espectáculos y entretenimiento',
        href: 'https://tnonetwork.com/show/showtime',
        showSlug: 'showtime',
      },
      {
        name: 'Entre Chicas TMF',
        note: 'Moda, estilo y conversación en antena',
        href: 'https://tnonetwork.com/show/entrechicastmf',
        showSlug: 'entrechicastmf',
      },
      {
        name: 'En el Proscenio',
        note: 'Teatro, cultura y espectáculos',
        href: 'https://tnonetwork.com/show/enelproscenio',
        showSlug: 'enelproscenio',
      },
      {
        name: '3 de Copas con Zidney',
        note: 'Transformación personal y conversación en comunidad',
        href: 'https://tnonetwork.com/show/3decopas',
        showSlug: '3decopas',
      },
      {
        name: 'Ni tan tu ni tan yo',
        note: 'Entretenimiento y conversación en antena',
        href: 'https://tnonetwork.com/show/nitantunitanyo',
        showSlug: 'nitantunitanyo',
      },
      {
        name: 'Más allá de la tendencia',
        note: 'Tendencias, entretenimiento y actualidad',
        href: 'https://tnonetwork.com/show/masalladelatendencia',
        showSlug: 'masalladelatendencia',
      },
      {
        name: '2do Escalón',
        note: 'Juvenil · entretenimiento y cultura pop',
        href: 'https://tnonetwork.com/show/2doescalon',
        showSlug: '2doescalon',
      },
    ],
  },
  {
    niche: 'Turismo',
    programs: [
      {
        name: 'Entérate con Flavia — Pasaporte Social',
        note: 'Flavia Sánchez · destinos, experiencias y conversación social en antena',
        href: 'https://tnonetwork.com/show/enterateconflavia',
        showSlug: 'enterateconflavia',
      },
    ],
  },
  {
    niche: 'Del fogón al micrófono',
    programs: [
      {
        name: 'Entérate con Flavia — Pasaporte Social',
        note: 'Flavia Sánchez · ruta gastronómica, experiencias y conversación social',
        href: 'https://tnonetwork.com/show/enterateconflavia',
        showSlug: 'enterateconflavia',
      },
      {
        name: 'Esto está sabrosito',
        note: 'Gastronomía, bebidas y experiencias culinarias en antena',
        href: 'https://tnonetwork.com/show/estoestasabrosito',
        showSlug: 'estoestasabrosito',
      },
    ],
  },
  {
    niche: 'Pasarela al aire',
    programs: [
      {
        name: 'Pescando la Moda',
        note: 'Tendencias, estilo y conversación fashion en antena',
        href: 'https://tnonetwork.com/show/pescandolamoda',
        showSlug: 'pescandolamoda',
      },
    ],
  },
  {
    niche: 'Segmentos y micros (rotación comercial)',
    programs: [
      { name: 'Activaciones feria / cobertura express', note: 'Coberturas en ferias y eventos aliados' },
      {
        name: 'Lion Bar · micros, segmentos y rotativa',
        note:
          'Presencia comercial unificada en TNO: micros en rotativa 24/7 (coctelería, mixología, licores y campañas por temporada) e integración en antena con segmentos de eventos, nightlife, agendas y activaciones en vivo.',
      },
      {
        name: 'Micros GPM Eventos en rotativa diaria',
        note: 'Video corto en grilla regular, alta rotación diaria en Radio Visual TNO',
      },
      {
        name: 'Micros LED Home · iluminación que transforma espacios',
        note:
          'Piezas cortas con before/after, tips de ambientación y soluciones LED para hogar, oficina y vitrinas: contenido visual que inspira compra y lleva tráfico directo al showroom.',
      },
      {
        name: 'Micros Salud al Día',
        note: 'Cápsulas breves de bienestar, prevención y hábitos saludables para rotativa comercial.',
        showSlug: 'saludaldia',
      },
      {
        name: 'Micros Supercines en TNO Network',
        note: 'Cápsulas de cartelera, estrenos y experiencia de sala en rotativa comercial.',
        showSlug: 'supercines',
      },
    ],
  },
];

/** Productos comerciales “acreditados” en el portafolio (donde la marca entra con reglas claras). */
export const accreditedCommercialServices = [
  { title: 'Patrocinio de programas en vivo', line: 'Show partner: menciones, corner, product placement y exclusividad de rubro cuando aplica.' },
  { title: 'Media Lab · On-Demand', line: '+40 producciones originales; narrativas de marca alineadas al tono TNO, no solo spot.' },
  { title: 'TNO Digest y presencia web', line: 'Artículos SEO, autoridad editorial y CTAs medibles en tnonetwork.com.' },
  { title: 'Brand awareness 24/7', line: 'Rotación de spot visual, cintillo digital y bloques comerciales no invasivos en la señal.' },
  { title: 'Ad-Tech y data', line: 'Visibilidad en catálogo y reporting de impactos para decisiones de mercadeo.' },
  { title: 'Integraciones en set (radio visual)', line: 'Logo, lower third, UGC y validación en contenido resolutivo (p. ej. vertical condominio).' },
  { title: 'Networking comercial TNOCON', line: 'Cara a cara con dirección comercial para cerrar parrilla + Media Lab en un solo plan.' },
];

/** Slide 6 · valores agregados para la marca (propuesta estratégica Día 3). */
export const tnoValueAdds = [
  {
    title: 'Producción in-house · Media Lab',
    text: 'Acceso al TNO Media Lab para piezas de alta calidad alineadas al tono de la señal y a su manual de marca.',
  },
  {
    title: 'Menciones orgánicas',
    text: 'El talento integra la marca en la narrativa: no como corte frío, sino como recomendación experta en contexto.',
  },
  {
    title: 'Data-driven',
    text: 'Decisiones apoyadas en el comportamiento real del usuario dentro de la plataforma y reportes de impacto.',
  },
  {
    title: 'Ubicación premium',
    text: 'Operaciones desde el hub empresarial de Las Mercedes, Caracas —cercanía con quienes definen la parrilla.',
  },
  {
    title: 'Ecosistema híbrido',
    text: 'Las marcas no solo «suenan»: viven en streaming en vivo, On-Demand de larga vida y Digest con autoridad SEO.',
  },
  {
    title: 'Roadmap 2026',
    text: 'Plataforma en evolución: IA de asistencia, recomendación y herramientas que acompañan su plan anual.',
  },
];

export function countActivePrograms() {
  return programGridByNiche.reduce((n, g) => n + g.programs.length, 0);
}

function normalizeProgramKey(s) {
  return String(s || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
}

function slugFromProgramHref(href) {
  const m = String(href || '').match(/\/show\/([^/?#]+)/i);
  return m ? decodeURIComponent(m[1]).trim() : '';
}

/**
 * Une la grilla estática por nichos con los shows del API (mismos que el catálogo On-Demand).
 * - No duplica por showSlug ni por nombre de programa (comparación normalizada).
 * - Si el género del API coincide con el título de un nicho estático, suma tarjetas ahí; si no, abre un bloque con el nombre del género.
 */
export function mergeProgramGridWithApiGroups(staticGrid, apiGroups, publicOrigin = 'https://tnonetwork.com') {
  if (!Array.isArray(staticGrid) || !staticGrid.length) return [];
  const base = String(publicOrigin || 'https://tnonetwork.com').replace(/\/$/, '');

  const knownNames = new Set();
  const knownSlugs = new Set();
  const out = staticGrid.map((g) => ({
    niche: g.niche,
    programs: (g.programs || []).map((p) => {
      knownNames.add(normalizeProgramKey(p.name));
      const staticSlug = String(p.showSlug || slugFromProgramHref(p.href) || '').trim();
      if (staticSlug) knownSlugs.add(normalizeProgramKey(staticSlug));
      return { ...p };
    }),
  }));

  if (!Array.isArray(apiGroups) || apiGroups.length === 0) {
    return out;
  }

  for (const block of apiGroups) {
    const genre = String(block.genre || '').trim() || 'En plataforma';
    const additions = [];
    for (const s of block.shows || []) {
      const name = String(s.name || s.showSlug || '').trim();
      if (!name) continue;
      const slug = String(s.showSlug || '').trim();
      const nameKey = normalizeProgramKey(name);
      const slugKey = normalizeProgramKey(slug);
      if (slugKey && knownSlugs.has(slugKey)) continue;
      if (knownNames.has(nameKey)) continue;
      if (slugKey) knownSlugs.add(slugKey);
      knownNames.add(nameKey);
      const onLive = s.isActive === true;
      additions.push({
        name,
        note: onLive ? 'En vivo y On-Demand' : 'Disponible en On-Demand',
        href: `${base}/show/${encodeURIComponent(slug)}`,
        showSlug: slug,
      });
    }
    if (!additions.length) continue;

    const idx = out.findIndex((g) => normalizeProgramKey(g.niche) === normalizeProgramKey(genre));
    if (idx >= 0) {
      out[idx] = { ...out[idx], programs: [...out[idx].programs, ...additions] };
    } else {
      out.push({ niche: genre, programs: additions });
    }
  }

  return out;
}

export function countProgramsInGrid(grid) {
  if (!Array.isArray(grid)) return 0;
  return grid.reduce((n, g) => n + (g.programs?.length || 0), 0);
}
